import { arrayMove } from '@dnd-kit/sortable';
import type { WorkbookColumnarSheet } from '@erp/shared-types';

export type SortKey = WorkbookColumnarSheet['sort'][number];

/** A sort order with the key at `from` moved to `to`. */
export function moveSortKey(
  sort: readonly SortKey[],
  from: number,
  to: number,
): SortKey[] {
  if (to < 0 || to >= sort.length || from === to) return [...sort];
  return arrayMove([...sort], from, to);
}
